export class Department {
    id = null;
    code = null;
    name = null;
    departmentType = null;
    parentId = null;
    parent = null;
    subDepartments = null;
    children = null;
    dupName = null;
    dupCode = null;
    displayOrder = null;
    level = null;
    linePath = null;
    shortName = null;
    rooms = null;
    duplicate = null;
    isUsing=true
    avgConsultationTime=null
}